export default "__VITE_ASSET__qdcKFbBC__"